var hourOptionalSecondsRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9](:([0-5][0-9]))?$/;
export function isTime(props, propName, componentName) {
    var _a = props, _b = propName, time = _a[_b];
    if (time) {
        if (typeof time !== 'string' || !hourOptionalSecondsRegExp.test(time)) {
            return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof time, "` supplied to `").concat(componentName, "`, expected time in HH:mm(:ss) format."));
        }
    }
    // Everything is fine
    return null;
}
